import { render, staticRenderFns } from "./UIBadge.vue?vue&type=template&id=9e7b5a9a&scoped=true"
import script from "./UIBadge.vue?vue&type=script&lang=js"
export * from "./UIBadge.vue?vue&type=script&lang=js"
import style0 from "./UIBadge.vue?vue&type=style&index=0&id=9e7b5a9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e7b5a9a",
  null
  
)

export default component.exports